<template>
  <div class="body-width  div-top">
    <ul class="breadcrumb ">
      <li class="li-padding-left20" @mouseenter="handleEnter('/producthsyl/VTSzhylxt')" @mouseleave="handleLeave('/producthsyl/VTSzhylxt')">
        <a @click="setroters('/producthsyl/VTSzhylxt')" >
        <span :class="VTSzhylxt?'font-Normal-1400':'font-Normal-14B6'">VTS指挥演练系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/producthsyl/hsltsjylxt')" @mouseleave="handleLeave('/producthsyl/hsltsjylxt')">
        <a @click="setroters('/producthsyl/hsltsjylxt')">
        <span :class="hsltsjylxt?'font-Normal-1400':'font-Normal-14B6'">海上立体搜救演练系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/producthsyl/hsyjylxt')" @mouseleave="handleLeave('/producthsyl/hsyjylxt')">
        <a @click="setroters('/producthsyl/hsyjylxt')">
        <span :class="hsyjylxt?'font-Normal-1400':'font-Normal-14B6'">海上应急演练系统</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/producthsyl/hjzzylxt')" @mouseleave="handleLeave('/producthsyl/hjzzylxt')">
        <a @click="setroters('/producthsyl/hjzzylxt')">
        <span :class="hjzzylxt?'font-Normal-1400':'font-Normal-14B6'">海军作战演练系统</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: "hsylheader",
    data() {
      return {
        VTSzhylxt: false,
        hsltsjylxt: false,
        hsyjylxt: false,
        hjzzylxt: false,

        isVTSzhylxt: false,
        ishsltsjylxt: false,
        ishsyjylxt: false,
        ishjzzylxt: false,
      }
    },
    methods: {
      handleEnter(src){
        if (src === '/producthsyl/VTSzhylxt') {
          this.VTSzhylxt = true
        }
        if (src === '/producthsyl/hsltsjylxt') {
          this.hsltsjylxt = true
        }
        if (src === '/producthsyl/hsyjylxt') {
          this.hsyjylxt = true
        }
        if (src === '/producthsyl/hjzzylxt') {
          this.hjzzylxt = true
        }
      },
      handleLeave(src){
        if (src === '/producthsyl/VTSzhylxt') {
          if(!this.isVTSzhylxt){
            this.VTSzhylxt = false
          }
        }
        if (src === '/producthsyl/hsltsjylxt') {
          if(!this.ishsltsjylxt){
            this.hsltsjylxt = false
          }
        }
        if (src === '/producthsyl/hsyjylxt') {
          if(!this.ishsyjylxt){
            this.hsyjylxt = false
          }
        }
        if (src === '/producthsyl/hjzzylxt') {
          if(!this.ishjzzylxt){
            this.hjzzylxt = false
          }
        }
      },
      setroters(src) {
        if (src === '/producthsyl/VTSzhylxt') {
          this.VTSzhylxt = true
          this.isVTSzhylxt = true
        } else {
          this.VTSzhylxt = false
          this.isVTSzhylxt = false
        }
        if (src === '/producthsyl/hsltsjylxt') {
          this.hsltsjylxt = true
          this.ishsltsjylxt = true
        } else {
          this.hsltsjylxt = false
          this.ishsltsjylxt = false
        }
        if (src === '/producthsyl/hsyjylxt') {
          this.hsyjylxt = true
          this.ishsyjylxt = true
        } else {
          this.hsyjylxt = false
          this.ishsyjylxt = false
        }
        if (src === '/producthsyl/hjzzylxt') {
          this.hjzzylxt = true
          this.ishjzzylxt = true
        } else {
          this.hjzzylxt = false
          this.ishjzzylxt = false
        }
        this.$router.push(src);
      }
    },
    mounted() {
      this.setroters('/producthsyl/VTSzhylxt');
    }
  }

</script>

<style scoped>
  .div-top {
    margin-top: 50px;
  }
.breadcrumb{
   background-color: #fbfbfb !important;
}
  .breadcrumb>li+li:before {
    color: #666666;
    content: "| ";
    padding: 0 16px;
  }

  .li-padding-left20 {
    padding-left: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hsylxlcp/hsylheader.vue